import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(() => ({
  initiativeLandingPage: {
    color: 'rgb(52, 27, 108)',
    fontSize: '20px',
    letterSpacing: '0.13px',
    lineHeight: '29px',
    paddingTop: '30px',
    paddingRight: '30px'
  }
}))
